import { TableCell } from "@mui/material";

interface ChildPartInfoColumnProps {
  version: "v1" | "v2";
}

const ChildPartInfoColumn = ({ version }: ChildPartInfoColumnProps) => {
  return (
    <>
      {version === "v1" && (
        <>
          <TableCell
            sx={{
              minWidth: 100,
              maxWidth: 100,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
            }}
          >
            OEM Price (THB/pcs)
          </TableCell>
          <TableCell
            sx={{
              minWidth: 100,
              maxWidth: 100,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
            }}
          >
            Spare Price (THB/pcs)
          </TableCell>
        </>
      )}
      <TableCell
        sx={{
          minWidth: 80,
          maxWidth: 80,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Q'Ty
      </TableCell>
      <TableCell
        sx={{
          minWidth: 300,
          maxWidth: 300,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
        }}
      >
        Material Code
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Material Price (THB/kg)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 100,
          maxWidth: 100,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Amount (pcs/lot)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Ratio
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Consumption (kg/pcs)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Part Weight (kg/pcs)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Scrap Weight (kg)
      </TableCell>
    </>
  );
};

export default ChildPartInfoColumn;
